module.exports = __webpack_public_path__ + "media/images/logos/passbase-app-843d88fadea58d978abc89eed038d7a5.png";